import { HospitalInfoRequestPayload } from "@/data/payload/hospital-info-request-payload";
import { HospitalRepository } from "@/domain/repository/hospital-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class DeleteHospitalUsecase {
  constructor(private readonly hospitalManageRepository: HospitalRepository) {}

  async execute(hospitalCode: string): Promise<SATResult<void, SATError>> {
    const payload: HospitalInfoRequestPayload = {
      hospitalCode: hospitalCode,
    };

    const result = await this.hospitalManageRepository.deleteHospitalInfo(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return SATResult.success(void 0);
  }
}
